module.exports = __webpack_public_path__ + "img/wuran.a7074b95.webp";